










































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { State, Action, Getter, Mutation } from "vuex-class";
import { API_URL } from "../global";

import { pageDataType, GalleryItem } from "../types";
import { FETCH_GALLERY } from "../store/actions.names";
import { HOST } from "../global";
import { pageData } from "@/store/pageData";
import {
  TimelineMax,
  Expo,
  TweenLite,
  TweenMax,
  Power2,
  Power3,
  Power1,
} from "gsap";

@Component({
  name: "GallaryPage",
})
export default class GallaryPage extends Vue {
  @Getter("galleryItems") public galleryItems!: GalleryItem[];
  @Action(FETCH_GALLERY) public [FETCH_GALLERY]: any;
  @Prop() public pageData!: pageDataType;
  @Getter("pageType") public pageType!: string | null;
  isImage: boolean = true;
  isVideo: boolean = false;
  index = null;
  current = null;
  imglistData: any[] = [];
  videolistData: any[] = [];
  image_list: any[] = [];
  video_list: any[] = [];
  newvideo_list: any[] = [];
  newimg_list: any[] = [];
  public HOST: string = HOST;
  public heroimganim() {
    var heroimganim = new TimelineMax({});
    heroimganim
      .from(".banner-wrap", 1.3, {
        y: "100%",
        ease: Expo.easeInOut,
        clearProps: "all",
      })
      .from(".banner-wrap img", 0.7, {
        y: 0,
        scale: 1.2,
        ease: Power2.easeInOut,
        clearProps: "all",
      })
      .staggerFrom(
        ".banner-text",
        0.8,
        {
          autoAlpha: 0,
          height: 0,
          ease: Expo.easeInOut,
          clearProps: "all",
        },
        0.01,
        "-=.3"
      )
      .staggerFrom(
        ".banner-text h1",
        0.8,
        {
          autoAlpha: 0,
          y: 80,
          ease: Expo.easeOut,
          clearProps: "all",
        },
        0.1,
        "-=.5"
      )
      .staggerFrom(
        ".banner-text p",
        0.8,
        {
          autoAlpha: 0,
          y: 80,
          ease: Expo.easeOut,
          clearProps: "all",
        },
        0.1,
        "-=.6"
      );
  }

  public get_images(newimg_list: any) {
    const imgData = newimg_list.map((each_image: any) => {
      return {
        src: this.HOST + each_image.src,
        title: each_image.title,
      };
    });
    return imgData;
  }

  VideoImglists() {
    this.imglistData = (this as any).galleryItems.results.filter(
      (imgitem: any) => {
        if (imgitem.type == "image") {
          return imgitem;
          
        }
       
      }
    );
    this.videolistData = (this as any).galleryItems.results.filter(
      (videitem: any) => {
        if (videitem.type == "video") {
          return videitem;
        }
      }
    );
   

  }
  myimages() {
    if (this.imglistData) {
      var imgData = this.imglistData;
      this.newimg_list = this.get_images(imgData);
    }
    // if (this.videolistData) {
    //  var videData = this.videolistData;

    //    this.newvideo_list = this.get_images(videData);
    // }
  }

  fetchImages() {
    this[FETCH_GALLERY]({
      type: "image",
    }).then((data: any) => {
      this.imglistData = data.results;
     this.imglistData = this.imglistData.sort(function(a, b){return b.id - a.id});
      this.myimages();
      // console.log(this.imglistData); 
    });
    
  }

  fetchVideos() {
    this[FETCH_GALLERY]({
      type: "video",
    }).then((data: any) => {
      this.videolistData = data.results;
       this.videolistData = this.videolistData.sort(function(a, b){return b.id - a.id});
    });
  }

  imgitemClick() {
    this.isImage = true;
    this.isVideo = false;
    this.fetchImages();
  }
  viditemClick() {
    this.isImage = false;
    this.isVideo = true;
    this.fetchVideos();
  }
 
  public mounted() {
    this.heroimganim();
    this.fetchImages();
  }
}
